// extracted by mini-css-extract-plugin
export var buttonsWrapper = "fG_lk";
export var ctaContainer = "fG_mq";
export var subtitle = "fG_k";
export var textContainer = "fG_cQ";